exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app{\n    height: 100%;\n    min-height: 100%;\n    overflow-x: hidden;\n    padding: 0px;\n}\n", ""]);

// exports
